import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  CHATBOT_INFO_FIELD_LIMITS,
  padChatbotInfoFields,
  type ChatbotInfoField,
} from '@workspace/types';

type InfoFieldsEditorProps = {
  fields: ChatbotInfoField[];
  onChange: (fields: ChatbotInfoField[]) => void;
  disabled?: boolean;
  idPrefix: string;
};

export function InfoFieldsEditor({
  fields,
  onChange,
  disabled = false,
  idPrefix,
}: InfoFieldsEditorProps) {
  const rows = padChatbotInfoFields(fields);

  const updateRow = (index: number, key: keyof ChatbotInfoField, value: string) => {
    const next = rows.map((row, rowIndex) =>
      rowIndex === index ? { ...row, [key]: value } : row,
    );
    onChange(next);
  };

  return (
    <div className='space-y-3'>
      {rows.map((row, index) => (
        <div key={`${idPrefix}-${index}`} className='grid gap-2 md:grid-cols-2'>
          <div>
            <Label htmlFor={`${idPrefix}-label-${index}`}>Etiqueta {index + 1}</Label>
            <Input
              id={`${idPrefix}-label-${index}`}
              maxLength={CHATBOT_INFO_FIELD_LIMITS.labelMax}
              value={row.label}
              disabled={disabled}
              placeholder='Ej: Horario / CUIT'
              onChange={event => updateRow(index, 'label', event.target.value.slice(0, CHATBOT_INFO_FIELD_LIMITS.labelMax))}
            />
          </div>
          <div>
            <Label htmlFor={`${idPrefix}-value-${index}`}>Valor {index + 1}</Label>
            <Input
              id={`${idPrefix}-value-${index}`}
              maxLength={CHATBOT_INFO_FIELD_LIMITS.valueMax}
              value={row.value}
              disabled={disabled}
              placeholder='Ej: 9 a 18 / 20-12345678-9'
              onChange={event => updateRow(index, 'value', event.target.value.slice(0, CHATBOT_INFO_FIELD_LIMITS.valueMax))}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
